import { TabContainerObject } from "page/Automatensuche/interface/TabControlTypes";

export function generateDefaultTabContainer(): TabContainerObject {
  return { STATIC_TAB_COUNT: 0, tabs: [], activeTab: 0 };
}
